import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { EMail } from '@models/peripherals/email';
import { EmailForm } from '@models/peripherals/email-form';
import { ConfirmPopupComponent } from '@shared/modal-popup/confirm-popup/confirm-popup.component';
@Component({
  selector: 'app-emailarray',
  templateUrl: './emailarray.component.html',
  styleUrls: ['./emailarray.component.css'],
})
export class EmailarrayComponent implements OnInit {
  @ViewChild(ConfirmPopupComponent) confirmModal: ConfirmPopupComponent;
  public isCollapsed = true;
  private emailType: string[];
  selectColor = '#aaaaaa';
  emailCounter: number;

  @Input()
  public emailFormArray: FormArray;

  @Input()
  public emailForm: EmailForm[];

  @Input()
  public emailTypes: string[];

  @Input()
  public parentId: number;

  @Output() deleteEmailEvent: EventEmitter<number> = new EventEmitter();
  @Output() checkMail: EventEmitter<any> = new EventEmitter();

  rows: number;
  static buildEmails() {
    return new FormArray([
      this.buildEmail(''),
    ]);
  }

  static buildFormEmail(val: EmailForm): any {
    return new FormGroup({
      email_id: new FormControl(val.emailID),
      email: new FormControl(val.url),
      emailType: new FormControl(val.type),
      emailAbout: new FormControl(val.about)
    });
  }

  static buildEmail(val: string): any {
    return new FormGroup({
      email_id: new FormControl(null),
      email: new FormControl(val),
      emailType: new FormControl(null),
      emailAbout: new FormControl(null)
    });
  }

  ngOnInit() {
    if (this.emailForm) {
      this.emailFormArray.removeAt(0);
      this.selectColor = '#000000';
      this.emailForm.forEach(element => {
        this.emailFormArray.push(EmailarrayComponent.buildFormEmail(element));
      });
    }
    this.emailCounter = this.emailForm.length;
  }

  emailChange() {
    this.checkMail.emit(this.emailFormArray.value)
  }

  addEmail() {
    this.emailFormArray.push(EmailarrayComponent.buildEmail(''));
    this.isCollapsed = false;
    this.emailCounter = this.emailCounter + 1;
  }

  changetxtRecord() {

  }

  deleteEmail(index) {
    let email_id = this.emailFormArray.controls[index.map_id].get('email_id').value;

    if (this.parentId) {

      this.deleteEmailEvent.emit(email_id);
      this.emailFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
    } else {
      this.emailFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
    }
    this.emailCounter = this.emailCounter - 1;
  }



  validEmail(event) {
    this.emailChange()
    let value = event.target.value;
    const pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (value != '' && !pattern.test(value)) {
      alert('Please Enter Valid Email ID.');
      (<HTMLInputElement>document.getElementById(event.target.id)).value = '';
    }
  }
  
  openConfirm(id) {
    this.confirmModal.showModal(id);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-control/email-form-control/emailarray.component.ts